import { render } from "./ModalBookPreview.vue?vue&type=template&id=37bfdb00&scoped=true"
import script from "./ModalBookPreview.vue?vue&type=script&lang=js"
export * from "./ModalBookPreview.vue?vue&type=script&lang=js"

import "./ModalBookPreview.vue?vue&type=style&index=0&id=37bfdb00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bfdb00"]])

export default __exports__